import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=5c5b925e&scoped=true&"
import script from "./DiscountItem.vue?vue&type=script&lang=js&"
export * from "./DiscountItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscountItem.vue?vue&type=style&index=0&id=5c5b925e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b925e",
  null
  
)

export default component.exports